export const PRE_ORDER_SMS_MESSAGE_TABLE = "preOrderSmsMessages"
export const PRE_ORDER_SMS_MESSAGE_TABLE_SCHEMA =
  "id, companyId, preOrderId, messageId, smsChatId, syncId, deletedAt"
